import React from 'react';
import { Ban, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Helmet } from 'react-helmet-async';

const ProhibitedItemsGuidePage = () => {
  return (
    <>
      <Helmet>
        <title>Prohibited Items for International Shipping | Restrictions Guide – Shippzy</title>
        <meta name="description" content="Complete list of prohibited and restricted items for international shipping from Canada. Know what you can and cannot ship worldwide." />
        <link rel="canonical" href="https://www.shippzy.ca/prohibited-items-international-shipping" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Prohibited Items for International Shipping</h1>
              <p className="text-xl text-gray-300 mb-8">Know what items cannot be shipped internationally from Canada to avoid delays and compliance issues.</p>
            </div>
          </div>
        </section>
        <section className="py-20 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-8 p-6 bg-red-50 border-l-4 border-red-500 rounded">
              <div className="flex gap-3"><Ban className="w-6 h-6 text-red-600 flex-shrink-0" /><div><h3 className="font-semibold text-gray-900 mb-2">Strictly Prohibited Items</h3><p className="text-gray-700">These items cannot be shipped internationally under any circumstances.</p></div></div>
            </div>
            <div className="space-y-6">
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Dangerous Materials</h3><p className="text-gray-600">Explosives, flammable liquids, flammable gases, toxic substances, radioactive materials, corrosives.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Weapons & Ammunition</h3><p className="text-gray-600">Firearms, ammunition, knives, martial arts weapons, explosives, fireworks.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Perishable Items</h3><p className="text-gray-600">Fresh food, frozen items, plants, seeds, live animals.</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Valuables</h3><p className="text-gray-600">Cash, negotiable instruments, precious metals/stones (unless properly declared and insured).</p></CardContent></Card>
              <Card><CardContent className="pt-6"><h3 className="font-semibold text-gray-900 mb-2">Restricted Electronics</h3><p className="text-gray-600">Items with large lithium batteries may have restrictions. Contact us for specific guidance.</p></CardContent></Card>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ProhibitedItemsGuidePage;